<template>
    <div>
        <el-tabs v-model="active" @tab-click="handleClick">
            <el-tab-pane label="个人资料" name="1">
                <el-descriptions style="margin-bottom: 20px" :column="2">
                    <el-descriptions-item label="头像">
                        <img style="width: 60px; height: 60px; border-radius: 30px" :src="ossUrl + form.avatar" alt="" />
                    </el-descriptions-item>
                    <el-descriptions-item label="性别">{{ { 1: "男", 2: "女" }[form.sex] }}</el-descriptions-item>
                    <el-descriptions-item label="用户名">{{ form.nick_name }}</el-descriptions-item>
                    <el-descriptions-item label="出生日期">{{ form.birth }}</el-descriptions-item>
                    <el-descriptions-item label="ID">{{ form.uuid }}</el-descriptions-item>
                    <el-descriptions-item label="职业">{{ form.job }}</el-descriptions-item>
                    <el-descriptions-item label="手机">{{ form.mobile || "/" }}</el-descriptions-item>
                    <el-descriptions-item label="城市">{{ address }}</el-descriptions-item>
                    <el-descriptions-item label="邮箱">{{ form.email || "/" }}</el-descriptions-item>
                    <el-descriptions-item label="兴趣">{{ form.interest }}</el-descriptions-item>
                    <el-descriptions-item label="关联标签">
                        <div style="display: flex; flex-wrap: wrap; gap: 5px">
                            <el-tag size="small" v-for="(item, index) in form.label" :key="index">{{ item.name }}</el-tag>
                        </div>
                    </el-descriptions-item>
                    <el-descriptions-item label="注册时间">{{ form.create_time }}</el-descriptions-item>
                    <el-descriptions-item label="收货地址">{{ form.address_detail }}</el-descriptions-item>
                    <el-descriptions-item label="关联cookie">
                        <el-link type="primary" :underline="false" @click="handleView">查看cookie</el-link>
                    </el-descriptions-item>
                </el-descriptions>
            </el-tab-pane>
            <el-tab-pane label="浏览记录" name="2">
                <ListPage
                    :query="query"
                    :total="total"
                    v-loading="loading"
                    :data="tableData"
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    @search="handleSearch"
                    @reset="resetQuery"
                >
                    <template slot="filters">
                        <el-form-item label="系列" prop="category_type">
                            <el-select v-model="query.category_type">
                                <el-option label="连接器" value="1"></el-option>
                                <el-option label="工具" value="2"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="分类" prop="search_category_uuid">
                            <CategorySelector
                                v-model="query.search_category_uuid"
                                :type="query.category_type"
                                :disabled="!query.category_type"
                            ></CategorySelector>
                        </el-form-item>
                        <el-form-item label="状态" prop="search_status">
                            <el-select v-model="query.search_status" placeholder="请选择状态">
                                <el-option label="正常" value="1" />
                                <el-option label="停售" value="2" />
                                <el-option label="下架" value="3" />
                            </el-select>
                        </el-form-item>
                    </template>
                    <template slot="columns">
                        <el-table-column label="序号" align="center" type="index" width="100" />
                        <el-table-column label="产品名称" align="center" prop="goods.name" />
                        <el-table-column label="分类" align="center">
                            <template slot-scope="{ row }">
                                {{ row.goods.cate_name.join(" ") }}
                            </template>
                        </el-table-column>
                        <el-table-column label="状态" align="center">
                            <template slot-scope="{ row }">
                                {{ { 1: "正常", 2: "停售", 3: "下架" }[row.goods.status] || "-" }}
                            </template>
                        </el-table-column>
                        <el-table-column label="时间" align="center" prop="create_time" />
                    </template>
                </ListPage>
            </el-tab-pane>
        </el-tabs>
        <el-button type="primary" style="width: 120px" @click="$router.back()">返回</el-button>
    </div>
</template>

<script>
import { detail, history } from "@/api/member/list";
import { ossUrl } from "@/configs/oss";
import listMixin from "@/mixins/list";
import CategorySelector from "@/components/CategorySelector";
export default {
    components: { CategorySelector },
    data() {
        return {
            ossUrl,
            active: "1",
            uuid: "",
            form: {},
            query: {
                search_category_uuid: "",
                search_status: "",
            },
        };
    },
    computed: {
        address() {
            const country = this.form.mcountry ? this.form.mcountry.zh_name : "";
            const province = this.form.mprovince ? this.form.mprovince.zh_name : "";
            const city = this.form.mcity ? this.form.mcity.zh_name : "";
            return `${country} ${province} ${city}`;
        },
    },
    mixins: [listMixin],
    mounted() {
        this.uuid = this.$route.query.uuid;
        this.getDetail();
        this.search();
    },
    methods: {
        handleClick({ name }) {
            if (name == 2) {
                this.search();
            }
        },
        search() {
            this.loading = true;
            if (!this.uuid) return;
            const params = {
                uuid: this.uuid,
                ...this.query,
            };
            history(params).then(({ code, result, error }) => {
                if (code === 200) {
                    this.tableData = result.data;
                    this.total = result.total;
                } else {
                    this.$message.error(error.message);
                }
                this.loading = false;
            });
        },
        getDetail() {
            detail({ uuid: this.uuid }).then(({ code, result, error }) => {
                if (code == 200) {
                    this.form = result || {};
                } else {
                    this.$message.error(error.message);
                }
            });
        },
        handleView() {
            this.$router.push({ path: "/user/detail", query: { uuid: this.form.cookie_user_uuid } });
        },
    },
};
</script>

<style></style>
